import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import { SchemaClientKinds, Source } from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";
import { uniqueSortedLabels } from "./filterValues";

/** One row of the filter-lookup table under the `maintenancePerformedBy` partition. */
export type ContactPerson = {
  filterValue: string;
};

/**
 * Maintainers, read from the same filter-lookup table as `Tags.ts` but from the
 * `maintenancePerformedBy` partition rather than `tags`.
 *
 * GraphQL only; see {@link getMaintainers}.
 */
const listContactPersons: Source<ContactPerson[]> = {
  graphql: parse(`
    query listIRFilterLookups($nextToken: String) {
      listIRFilterLookups(
        limit: 1000,
        nextToken: $nextToken,
        filterAttribute: "contactPerson",
        sortDirection: ASC
      ) {
        nextToken
        items {
          filterValue
        }
      }
    }
  `),
};

/**
 * Contact person filter options.
 *
 * Answers `[]` for any client that is not GraphQL. TODO: no DynamoDB request is declared yet.
 * The physical table is the one `DynamoDbTables.TAGS` already names — the lookup table
 * partitions by `filterAttribute` — so this is the cheapest of the four to complete later.
 * Safe as a stub because these values only populate a grid filter dropdown and never reach
 * `DataManager`.
 *
 * @param client - Read client for the master data.
 * @returns Contact persons names, deduplicated and sorted.
 */
export const getContactPersons = async (client: SchemaClient): Promise<string[]> => {
  if (client.kind !== SchemaClientKinds.GRAPHQL) {
    console.warn("getContactPersons: client is not GraphQL, returning empty list!");
    return [];
  }
  const contactPersons = await client.queryList(listContactPersons);
  const items = contactPersons === EMPTY_VALUE ? [] : contactPersons ?? [];
  return uniqueSortedLabels(items.map((contactPerson) => contactPerson.filterValue));
};
